module.exports = __webpack_public_path__ + "assets/img/9_307.8d122fe3.jpg";